(() => {
  // node_modules/@studio-freight/lenis/dist/lenis.modern.mjs
  function t() {
    return t = Object.assign ? Object.assign.bind() : function(t2) {
      for (var e2 = 1; e2 < arguments.length; e2++) {
        var i2 = arguments[e2];
        for (var s2 in i2)
          Object.prototype.hasOwnProperty.call(i2, s2) && (t2[s2] = i2[s2]);
      }
      return t2;
    }, t.apply(this, arguments);
  }
  function e(t2, e2, i2) {
    return Math.max(t2, Math.min(e2, i2));
  }
  var i = class {
    advance(t2) {
      var i2;
      if (!this.isRunning)
        return;
      let s2 = false;
      if (this.lerp)
        this.value = (o2 = this.value, n2 = this.to, (1 - (r2 = 1 - Math.exp(-60 * this.lerp * t2))) * o2 + r2 * n2), Math.round(this.value) === this.to && (this.value = this.to, s2 = true);
      else {
        this.currentTime += t2;
        const i3 = e(0, this.currentTime / this.duration, 1);
        s2 = i3 >= 1;
        const o3 = s2 ? 1 : this.easing(i3);
        this.value = this.from + (this.to - this.from) * o3;
      }
      var o2, n2, r2;
      (i2 = this.onUpdate) == null || i2.call(this, this.value, { completed: s2 }), s2 && this.stop();
    }
    stop() {
      this.isRunning = false;
    }
    fromTo(t2, e2, { lerp: i2 = 0.1, duration: s2 = 1, easing: o2 = (t3) => t3, onUpdate: n2 }) {
      this.from = this.value = t2, this.to = e2, this.lerp = i2, this.duration = s2, this.easing = o2, this.currentTime = 0, this.isRunning = true, this.onUpdate = n2;
    }
  };
  var s = class {
    constructor({ wrapper: t2, content: e2, autoResize: i2 = true } = {}) {
      if (this.resize = () => {
        this.onWrapperResize(), this.onContentResize();
      }, this.onWrapperResize = () => {
        this.wrapper === window ? (this.width = window.innerWidth, this.height = window.innerHeight) : (this.width = this.wrapper.clientWidth, this.height = this.wrapper.clientHeight);
      }, this.onContentResize = () => {
        this.scrollHeight = this.content.scrollHeight, this.scrollWidth = this.content.scrollWidth;
      }, this.wrapper = t2, this.content = e2, i2) {
        const t3 = function(t4, e3) {
          let i3;
          return function() {
            let e4 = arguments, s2 = this;
            clearTimeout(i3), i3 = setTimeout(function() {
              t4.apply(s2, e4);
            }, 250);
          };
        }(this.resize);
        this.wrapper !== window && (this.wrapperResizeObserver = new ResizeObserver(t3), this.wrapperResizeObserver.observe(this.wrapper)), this.contentResizeObserver = new ResizeObserver(t3), this.contentResizeObserver.observe(this.content);
      }
      this.resize();
    }
    destroy() {
      var t2, e2;
      (t2 = this.wrapperResizeObserver) == null || t2.disconnect(), (e2 = this.contentResizeObserver) == null || e2.disconnect();
    }
    get limit() {
      return { x: this.scrollWidth - this.width, y: this.scrollHeight - this.height };
    }
  };
  var o = () => ({ events: {}, emit(t2, ...e2) {
    let i2 = this.events[t2] || [];
    for (let t3 = 0, s2 = i2.length; t3 < s2; t3++)
      i2[t3](...e2);
  }, on(t2, e2) {
    var i2;
    return ((i2 = this.events[t2]) == null ? void 0 : i2.push(e2)) || (this.events[t2] = [e2]), () => {
      var i3;
      this.events[t2] = (i3 = this.events[t2]) == null ? void 0 : i3.filter((t3) => e2 !== t3);
    };
  } });
  var n = class {
    constructor(t2, { wheelMultiplier: i2 = 1, touchMultiplier: s2 = 2, normalizeWheel: n2 = false }) {
      this.onTouchStart = (t3) => {
        const { clientX: e2, clientY: i3 } = t3.targetTouches ? t3.targetTouches[0] : t3;
        this.touchStart.x = e2, this.touchStart.y = i3, this.lastDelta = { x: 0, y: 0 };
      }, this.onTouchMove = (t3) => {
        const { clientX: e2, clientY: i3 } = t3.targetTouches ? t3.targetTouches[0] : t3, s3 = -(e2 - this.touchStart.x) * this.touchMultiplier, o2 = -(i3 - this.touchStart.y) * this.touchMultiplier;
        this.touchStart.x = e2, this.touchStart.y = i3, this.lastDelta = { x: s3, y: o2 }, this.emitter.emit("scroll", { type: "touch", deltaX: s3, deltaY: o2, event: t3 });
      }, this.onTouchEnd = (t3) => {
        this.emitter.emit("scroll", { type: "touch", inertia: true, deltaX: this.lastDelta.x, deltaY: this.lastDelta.y, event: t3 });
      }, this.onWheel = (t3) => {
        let { deltaX: i3, deltaY: s3 } = t3;
        this.normalizeWheel && (i3 = e(-100, i3, 100), s3 = e(-100, s3, 100)), i3 *= this.wheelMultiplier, s3 *= this.wheelMultiplier, this.emitter.emit("scroll", { type: "wheel", deltaX: i3, deltaY: s3, event: t3 });
      }, this.element = t2, this.wheelMultiplier = i2, this.touchMultiplier = s2, this.normalizeWheel = n2, this.touchStart = { x: null, y: null }, this.emitter = o(), this.element.addEventListener("wheel", this.onWheel, { passive: false }), this.element.addEventListener("touchstart", this.onTouchStart, { passive: false }), this.element.addEventListener("touchmove", this.onTouchMove, { passive: false }), this.element.addEventListener("touchend", this.onTouchEnd, { passive: false });
    }
    on(t2, e2) {
      return this.emitter.on(t2, e2);
    }
    destroy() {
      this.emitter.events = {}, this.element.removeEventListener("wheel", this.onWheel, { passive: false }), this.element.removeEventListener("touchstart", this.onTouchStart, { passive: false }), this.element.removeEventListener("touchmove", this.onTouchMove, { passive: false }), this.element.removeEventListener("touchend", this.onTouchEnd, { passive: false });
    }
  };
  var r = class {
    constructor({ direction: e2, gestureDirection: r2, mouseMultiplier: l, smooth: h, wrapper: a = window, content: c = document.documentElement, wheelEventsTarget: u = a, smoothWheel: p = h == null || h, smoothTouch: m = false, syncTouch: d = false, syncTouchLerp: v = 0.1, touchInertiaMultiplier: g = 35, duration: S, easing: w = (t2) => Math.min(1, 1.001 - Math.pow(2, -10 * t2)), lerp: f = S ? null : 0.1, infinite: y = false, orientation: T = e2 != null ? e2 : "vertical", gestureOrientation: z = r2 != null ? r2 : "vertical", touchMultiplier: M = 1, wheelMultiplier: L = l != null ? l : 1, normalizeWheel: E = false, autoResize: b = true } = {}) {
      this.onVirtualScroll = ({ type: e3, inertia: i2, deltaX: s2, deltaY: o2, event: n2 }) => {
        if (n2.ctrlKey)
          return;
        const r3 = e3 === "touch", l2 = e3 === "wheel";
        if (this.options.gestureOrientation === "vertical" && o2 === 0 || this.options.gestureOrientation === "horizontal" && s2 === 0 || r3 && this.options.gestureOrientation === "vertical" && this.scroll === 0 && !this.options.infinite && o2 <= 0)
          return;
        if (n2.composedPath().find((t2) => (t2 == null || t2.hasAttribute == null ? void 0 : t2.hasAttribute("data-lenis-prevent")) || r3 && (t2 == null || t2.hasAttribute == null ? void 0 : t2.hasAttribute("data-lenis-prevent-touch")) || l2 && (t2 == null || t2.hasAttribute == null ? void 0 : t2.hasAttribute("data-lenis-prevent-wheel"))))
          return;
        if (this.isStopped || this.isLocked)
          return void n2.preventDefault();
        if (this.isSmooth = (this.options.smoothTouch || this.options.syncTouch) && r3 || this.options.smoothWheel && l2, !this.isSmooth)
          return this.isScrolling = false, void this.animate.stop();
        n2.preventDefault();
        let h2 = o2;
        this.options.gestureOrientation === "both" ? h2 = Math.abs(o2) > Math.abs(s2) ? o2 : s2 : this.options.gestureOrientation === "horizontal" && (h2 = s2);
        const a2 = r3 && this.options.syncTouch, c2 = r3 && i2 && Math.abs(h2) > 1;
        c2 && (h2 = this.velocity * this.options.touchInertiaMultiplier), this.scrollTo(this.targetScroll + h2, t({ programmatic: false }, a2 && { lerp: c2 ? this.syncTouchLerp : 0.4 }));
      }, this.onScroll = () => {
        if (!this.isScrolling) {
          const t2 = this.animatedScroll;
          this.animatedScroll = this.targetScroll = this.actualScroll, this.velocity = 0, this.direction = Math.sign(this.animatedScroll - t2), this.emit();
        }
      }, e2 && console.warn("Lenis: `direction` option is deprecated, use `orientation` instead"), r2 && console.warn("Lenis: `gestureDirection` option is deprecated, use `gestureOrientation` instead"), l && console.warn("Lenis: `mouseMultiplier` option is deprecated, use `wheelMultiplier` instead"), h && console.warn("Lenis: `smooth` option is deprecated, use `smoothWheel` instead"), window.lenisVersion = "1.0.15", a !== document.documentElement && a !== document.body || (a = window), this.options = { wrapper: a, content: c, wheelEventsTarget: u, smoothWheel: p, smoothTouch: m, syncTouch: d, syncTouchLerp: v, touchInertiaMultiplier: g, duration: S, easing: w, lerp: f, infinite: y, gestureOrientation: z, orientation: T, touchMultiplier: M, wheelMultiplier: L, normalizeWheel: E, autoResize: b }, this.dimensions = new s({ wrapper: a, content: c, autoResize: b }), this.rootElement.classList.add("lenis"), this.velocity = 0, this.isStopped = false, this.isSmooth = p || m, this.isScrolling = false, this.targetScroll = this.animatedScroll = this.actualScroll, this.animate = new i(), this.emitter = o(), this.options.wrapper.addEventListener("scroll", this.onScroll, { passive: false }), this.virtualScroll = new n(u, { touchMultiplier: M, wheelMultiplier: L, normalizeWheel: E }), this.virtualScroll.on("scroll", this.onVirtualScroll);
    }
    destroy() {
      this.emitter.events = {}, this.options.wrapper.removeEventListener("scroll", this.onScroll, { passive: false }), this.virtualScroll.destroy(), this.dimensions.destroy(), this.rootElement.classList.remove("lenis"), this.rootElement.classList.remove("lenis-smooth"), this.rootElement.classList.remove("lenis-scrolling"), this.rootElement.classList.remove("lenis-stopped");
    }
    on(t2, e2) {
      return this.emitter.on(t2, e2);
    }
    off(t2, e2) {
      var i2;
      this.emitter.events[t2] = (i2 = this.emitter.events[t2]) == null ? void 0 : i2.filter((t3) => e2 !== t3);
    }
    setScroll(t2) {
      this.isHorizontal ? this.rootElement.scrollLeft = t2 : this.rootElement.scrollTop = t2;
    }
    resize() {
      this.dimensions.resize();
    }
    emit() {
      this.emitter.emit("scroll", this);
    }
    reset() {
      this.isLocked = false, this.isScrolling = false, this.velocity = 0, this.animate.stop();
    }
    start() {
      this.isStopped = false, this.reset();
    }
    stop() {
      this.isStopped = true, this.animate.stop(), this.reset();
    }
    raf(t2) {
      const e2 = t2 - (this.time || t2);
      this.time = t2, this.animate.advance(1e-3 * e2);
    }
    scrollTo(t2, { offset: i2 = 0, immediate: s2 = false, lock: o2 = false, duration: n2 = this.options.duration, easing: r2 = this.options.easing, lerp: l = !n2 && this.options.lerp, onComplete: h = null, force: a = false, programmatic: c = true } = {}) {
      if (!this.isStopped || a) {
        if (["top", "left", "start"].includes(t2))
          t2 = 0;
        else if (["bottom", "right", "end"].includes(t2))
          t2 = this.limit;
        else {
          var u;
          let e2;
          if (typeof t2 == "string" ? e2 = document.querySelector(t2) : (u = t2) != null && u.nodeType && (e2 = t2), e2) {
            if (this.options.wrapper !== window) {
              const t3 = this.options.wrapper.getBoundingClientRect();
              i2 -= this.isHorizontal ? t3.left : t3.top;
            }
            const s3 = e2.getBoundingClientRect();
            t2 = (this.isHorizontal ? s3.left : s3.top) + this.animatedScroll;
          }
        }
        if (typeof t2 == "number") {
          if (t2 += i2, t2 = Math.round(t2), this.options.infinite ? c && (this.targetScroll = this.animatedScroll = this.scroll) : t2 = e(0, t2, this.limit), s2)
            return this.animatedScroll = this.targetScroll = t2, this.setScroll(this.scroll), this.reset(), this.emit(), void (h == null || h());
          if (!c) {
            if (t2 === this.targetScroll)
              return;
            this.targetScroll = t2;
          }
          this.animate.fromTo(this.animatedScroll, t2, { duration: n2, easing: r2, lerp: l, onUpdate: (t3, { completed: e2 }) => {
            o2 && (this.isLocked = true), this.isScrolling = true, this.velocity = t3 - this.animatedScroll, this.direction = Math.sign(this.velocity), this.animatedScroll = t3, this.setScroll(this.scroll), c && (this.targetScroll = t3), e2 && (o2 && (this.isLocked = false), requestAnimationFrame(() => {
              this.isScrolling = false;
            }), this.velocity = 0, h == null || h()), this.emit();
          } });
        }
      }
    }
    get rootElement() {
      return this.options.wrapper === window ? this.options.content : this.options.wrapper;
    }
    get limit() {
      return this.isHorizontal ? this.dimensions.limit.x : this.dimensions.limit.y;
    }
    get isHorizontal() {
      return this.options.orientation === "horizontal";
    }
    get actualScroll() {
      return this.isHorizontal ? this.rootElement.scrollLeft : this.rootElement.scrollTop;
    }
    get scroll() {
      return this.options.infinite ? (this.animatedScroll % (t2 = this.limit) + t2) % t2 : this.animatedScroll;
      var t2;
    }
    get progress() {
      return this.limit === 0 ? 1 : this.scroll / this.limit;
    }
    get isSmooth() {
      return this.__isSmooth;
    }
    set isSmooth(t2) {
      this.__isSmooth !== t2 && (this.rootElement.classList.toggle("lenis-smooth", t2), this.__isSmooth = t2);
    }
    get isScrolling() {
      return this.__isScrolling;
    }
    set isScrolling(t2) {
      this.__isScrolling !== t2 && (this.rootElement.classList.toggle("lenis-scrolling", t2), this.__isScrolling = t2);
    }
    get isStopped() {
      return this.__isStopped;
    }
    set isStopped(t2) {
      this.__isStopped !== t2 && (this.rootElement.classList.toggle("lenis-stopped", t2), this.__isStopped = t2);
    }
  };

  // src/scripts/utils/math.js
  var randomInRange = (min, max) => {
    return Math.random() * (max - min) + min;
  };

  // src/scripts/utils/shopify.js
  var trimThemeEditorTags = function(data) {
    return data.replace(/<\/?[^>]+>/gim, "");
  };

  // src/scripts/pages/flexible.js
  var FlexiblePage = class {
    constructor(el) {
      this.el = el;
      this.isProducer = el.classList.contains("producer");
      this.banner = this.el.querySelector(".banner > div");
      this.body = this.el.querySelector(".js-page-body");
      this.setDOM();
      this.fixAccordions();
    }
    setDOM() {
      if (this.isProducer && this.banner) {
        const mm = gsap.matchMedia();
        mm.add("(min-width: 1024px)", () => {
          gsap.fromTo(this.banner, {
            "--p": 1
          }, {
            "--p": 0,
            scrollTrigger: {
              trigger: this.banner,
              start: "70% 90%",
              end: "center center",
              scrub: 2
            }
          });
        });
      }
      this.firstP = this.body.querySelector("p");
      this.firstP && this.firstP.classList.add("-intro", "-modified");
      this.tables = Array.from(this.body.querySelectorAll("table"));
      this.tables.forEach((table) => {
        const tbody = table.children[0];
        Array.from(tbody.children).forEach((tr) => {
          const firstTd = tr.children[0];
          console.log(firstTd.children[0]);
          if (firstTd.children[0] && firstTd.children[0].tagName.toLowerCase() === "img") {
            firstTd.classList.add("-img");
            tr.children[1].classList.add("-text");
          } else {
            tr.children[0].classList.add("-text");
            tr.children[1].classList.add("-img");
          }
        });
      });
      this.ulLists = Array.from(this.body.querySelectorAll("ul"));
      this.ulLists = this.ulLists.filter((ul) => !ul.closest("table"));
      this.ulTables = this.ulLists.filter((ul) => ul.children[0].innerText.includes("//"));
      if (this.ulTables.length) {
        this.ulTables.forEach((ul) => {
          ul.classList.add("-table");
          Array.from(ul.children).forEach((li) => {
            let [left, ...right] = li.innerHTML.split("//");
            right = right.join("//");
            const html = [left, right].map((c) => `<div>${c.trim()}</div>`);
            li.innerHTML = html.join("");
          });
        });
      }
      this.ulSlideshows = this.ulLists.filter((ul) => {
        const liFirstChild = ul.children[0].children[0];
        return liFirstChild && liFirstChild.tagName.toLowerCase() === "img";
      });
      if (this.ulSlideshows.length) {
        this.ulSlideshows.forEach((ul) => this.createSlideshow(ul));
      }
      this.ulProducts = this.ulLists.filter((ul) => {
        const liFirstChild = ul.children[0].children[0];
        return liFirstChild && liFirstChild.tagName.toLowerCase() === "a" && liFirstChild.href.includes("/products/");
      });
      const jsProductsList = document.querySelector(".js-products-list");
      if (jsProductsList) {
        this.ulProducts.push(jsProductsList);
        const jsProductsBtn = document.querySelector('a[href="#products"]');
        jsProductsBtn && jsProductsBtn.addEventListener("click", (e2) => {
          e2.preventDefault();
          jsProductsList.parentElement.scrollIntoView({
            behavior: "smooth"
          });
        });
      }
      if (this.ulProducts.length) {
        this.prepareProductTiles();
        this.ulProducts.forEach((ul) => this.createProductTiles(ul));
      }
      this.olLists = Array.from(this.body.querySelectorAll("ol"));
      this.olLists = this.olLists.filter((ol) => !ol.closest("table"));
      this.olLists.forEach((ol) => {
        const div = document.createElement("div");
        div.classList.add("accordions");
        let html = "";
        for (let i2 = 0; i2 < ol.children.length; i2 = i2 + 2) {
          html += `
            <details class="acc" id="Details-{{ mf }}">
                <summary>
                    <h2 class="t-h6">${ol.children[i2].innerText}</h2>
                    <div class="accordion-trigger"></div>
                </summary>
                <div class="content t-body" id="ProductAccordion-{{ mf }}">
                    ${ol.children[i2 + 1].innerHTML}
                </div>
            </details>
        `;
        }
        div.innerHTML = html;
        ol.parentElement.replaceChild(div, ol);
      });
      this.strongs = Array.from(this.body.querySelectorAll("strong"));
      this.strongs.forEach((strong) => {
        if (strong.closest("table"))
          return;
        const p = document.createElement("p");
        p.classList.add("t-h6", "-modified");
        p.innerText = strong.innerText;
        strong.parentElement.replaceChild(p, strong);
      });
      this.h3s = Array.from(this.body.querySelectorAll("h3"));
      this.h3s.forEach((h3) => {
        const p = document.createElement("p");
        p.classList.add("t-h3", "-modified");
        p.innerText = h3.innerText;
        h3.parentElement.replaceChild(p, h3);
      });
      this.mapsEl = Array.from(this.body.querySelectorAll("a[href*='maps']"));
      this.mapsEl.length && this.initMaps();
      this.anchorEl = this.body.querySelector("a[href='#anchor']");
      if (this.anchorEl)
        this.createAnchorLink();
    }
    createSlideshow(el) {
      const swiperEl = document.createElement("div");
      swiperEl.classList.add("slideshow");
      swiperEl.innerHTML = `
        <div class="slideshow__buttons">
            <button class="swiper-btn prev-btn" aria-label="${Shopify.locale === "en" ? "Previous slide" : "Diapositive pr\xE9c\xE9dente"}">
                <svg viewBox="0 0 25 19" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M5.321 11.833c.941.947 2.776 2.652 4.115 3.897.53.493.972.905 1.23 1.147l-2.179 2.064c-1.39-1.918-5.56-6.024-7.97-7.842V8.133C2.928 6.313 7.096 2.207 8.49.29l2.178 2.064c-.5.476-1.205 1.134-1.951 1.827C7.45 5.36 6.019 6.696 5.32 7.397l-.635.639h16.638c.616 0 1.231-.077 1.825-.15.285-.036.574-.071.859-.098v3.653a24.275 24.275 0 0 1-.851-.097c-.602-.075-1.217-.152-1.833-.152H4.686l.635.64v.001Z" fill="currentColor"/>
                </svg>
            </button>
            <button class="swiper-btn next-btn" aria-label="${Shopify.locale === "en" ? "Next slide" : "Diapositive suivante"}">
                <svg viewBox="0 0 25 19" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M19.678 11.833c-.94.947-2.775 2.652-4.114 3.897-.53.493-.972.905-1.23 1.147l2.179 2.064c1.39-1.918 5.56-6.024 7.97-7.842V8.133c-2.41-1.82-6.578-5.926-7.972-7.844l-2.178 2.064c.5.476 1.205 1.134 1.951 1.827 1.265 1.18 2.697 2.516 3.395 3.217l.635.639H3.676c-.616 0-1.231-.077-1.825-.15a26.726 26.726 0 0 0-.859-.098v3.653c.285-.026.572-.061.851-.097.602-.075 1.217-.152 1.833-.152h16.638l-.636.64v.001Z" fill="currentColor"/>
                </svg>
            </button>
        </div>
        <div class="swiper">
            <div class="swiper-wrapper">
                ${Array.from(el.children).map((li) => {
        li.children[0].loading = "lazy";
        li.children[0].decoding = "async";
        return `<div class="swiper-slide">
                      <div class="media-filter">
                        <div class="inner">
                          ${li.innerHTML}
                        </div>
                      </div>
                        ${li.children[0].alt ? `<p class="t-small-text">${li.children[0].alt}</p>` : ""}
                    </div>`;
      }).join("")}
            </div>
        </div>
    `;
      el.parentElement.replaceChild(swiperEl, el);
      const swiper = new Swiper(swiperEl.querySelector(".swiper"), {
        speed: 600,
        slidesPerView: 1,
        grabCursor: true,
        navigation: {
          nextEl: swiperEl.querySelector(".next-btn"),
          prevEl: swiperEl.querySelector(".prev-btn")
        }
      });
    }
    prepareProductTiles() {
      this.productTpl = this.el.querySelector("template#product-tile-tpl");
      this.productTile = this.productTpl.content.querySelector("div");
    }
    createProductTiles(el) {
      el.classList.add("products-list");
      const lang = Shopify.locale == "en" ? "" : "/fr";
      const url = `${window.location.origin}${lang}/products`;
      Array.from(el.children).forEach(async (li) => {
        const a = li.children[0];
        const slug = a.href.split("/products/")[1];
        const product = await fetch(`${url}/${slug}?view=json`).then((response) => response.text()).then((data) => {
          try {
            data = JSON.parse(trimThemeEditorTags(data));
          } catch (error) {
          }
          return data;
        });
        this.createProductTile(li, product);
      });
    }
    createProductTile(li, item) {
      const clone = document.importNode(this.productTile, true);
      let hoverText;
      if (item.type === "Box") {
        hoverText = item.short_infos;
      } else {
        hoverText = item.ingredients;
      }
      clone.innerHTML = clone.innerHTML.replace("%url%", item.url).replace("data-href=", "href=").replace("%featured_media%", item.featured_media ? item.featured_media : "").replace("%title%", item.title).replace("%price%", item.price).replace("%hover_text%", hoverText);
      clone.innerHTML = clone.innerHTML.replace("data-tile-src=", "src=");
      if (item.type === "Box") {
        clone.innerHTML = clone.innerHTML.replace("%hover_table%", item.short_details);
      } else {
        clone.innerHTML = clone.innerHTML.replace("%collection%", item.custom_type || item.collection).replace("%origin%", item.origin).replace("%process%", item.process);
      }
      clone.firstElementChild.classList.add(`-${item.type.toLowerCase()}`);
      const tile = clone.firstElementChild;
      li.replaceChild(tile, li.children[0]);
    }
    initMaps() {
      this.mapsLoader = new google.maps.plugins.loader.Loader({
        apiKey: "AIzaSyCimOf7OxfDGmuhFJczGs2FroH-PW67xac",
        version: "weekly"
      });
      this.mapsLoader.load().then(this.createMaps.bind(this));
    }
    createMaps() {
      this.mapsEl.forEach((mapEl) => {
        const href = mapEl.href.endsWith("/") ? mapEl.href.slice(0, -1) : mapEl.href;
        const splits = href.split("/@");
        const latLng = splits[1].split(",");
        const newMapEl = document.createElement("div");
        newMapEl.classList.add("map");
        mapEl.parentElement.replaceChild(newMapEl, mapEl);
        const pos = new google.maps.LatLng(parseFloat(latLng[0]), parseFloat(latLng[1]));
        const map = new google.maps.Map(newMapEl, {
          zoom: 12,
          center: pos,
          disableDefaultUI: true,
          zoomControl: true,
          styles: [
            {
              "featureType": "all",
              "elementType": "all",
              "stylers": [
                {
                  "visibility": "on"
                }
              ]
            },
            {
              "featureType": "administrative",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#444444"
                }
              ]
            },
            {
              "featureType": "administrative.province",
              "elementType": "all",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "administrative.locality",
              "elementType": "all",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "administrative.neighborhood",
              "elementType": "all",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "administrative.land_parcel",
              "elementType": "all",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "administrative.land_parcel",
              "elementType": "labels.text",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "landscape",
              "elementType": "all",
              "stylers": [
                {
                  "color": "#ededeb"
                }
              ]
            },
            {
              "featureType": "landscape.man_made",
              "elementType": "all",
              "stylers": [
                {
                  "visibility": "simplified"
                }
              ]
            },
            {
              "featureType": "poi",
              "elementType": "all",
              "stylers": [
                {
                  "visibility": "off"
                },
                {
                  "color": "#cee9de"
                },
                {
                  "saturation": "2"
                },
                {
                  "weight": "0.80"
                }
              ]
            },
            {
              "featureType": "poi",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "lightness": "-32"
                }
              ]
            },
            {
              "featureType": "poi.attraction",
              "elementType": "geometry.fill",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "poi.park",
              "elementType": "all",
              "stylers": [
                {
                  "visibility": "on"
                }
              ]
            },
            {
              "featureType": "road",
              "elementType": "all",
              "stylers": [
                {
                  "saturation": -100
                },
                {
                  "lightness": 45
                }
              ]
            },
            {
              "featureType": "road.highway",
              "elementType": "all",
              "stylers": [
                {
                  "visibility": "simplified"
                }
              ]
            },
            {
              "featureType": "road.highway",
              "elementType": "geometry.fill",
              "stylers": [
                {
                  "visibility": "on"
                },
                {
                  "color": "#f5d6d6"
                }
              ]
            },
            {
              "featureType": "road.highway",
              "elementType": "labels.text",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "road.highway",
              "elementType": "labels.icon",
              "stylers": [
                {
                  "hue": "#ff0000"
                },
                {
                  "visibility": "on"
                }
              ]
            },
            {
              "featureType": "road.highway.controlled_access",
              "elementType": "labels.text",
              "stylers": [
                {
                  "visibility": "simplified"
                }
              ]
            },
            {
              "featureType": "road.highway.controlled_access",
              "elementType": "labels.icon",
              "stylers": [
                {
                  "visibility": "on"
                },
                {
                  "hue": "#0064ff"
                },
                {
                  "gamma": "1.44"
                },
                {
                  "lightness": "-3"
                },
                {
                  "weight": "1.69"
                }
              ]
            },
            {
              "featureType": "road.arterial",
              "elementType": "all",
              "stylers": [
                {
                  "visibility": "on"
                }
              ]
            },
            {
              "featureType": "road.arterial",
              "elementType": "labels.text",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "road.arterial",
              "elementType": "labels.icon",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "road.local",
              "elementType": "all",
              "stylers": [
                {
                  "visibility": "on"
                }
              ]
            },
            {
              "featureType": "road.local",
              "elementType": "labels.text",
              "stylers": [
                {
                  "visibility": "simplified"
                },
                {
                  "weight": "0.31"
                },
                {
                  "gamma": "1.43"
                },
                {
                  "lightness": "-5"
                },
                {
                  "saturation": "-22"
                }
              ]
            },
            {
              "featureType": "transit",
              "elementType": "all",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "transit.line",
              "elementType": "all",
              "stylers": [
                {
                  "visibility": "on"
                },
                {
                  "hue": "#ff0000"
                }
              ]
            },
            {
              "featureType": "transit.station.airport",
              "elementType": "all",
              "stylers": [
                {
                  "visibility": "simplified"
                },
                {
                  "hue": "#ff0045"
                }
              ]
            },
            {
              "featureType": "transit.station.bus",
              "elementType": "all",
              "stylers": [
                {
                  "visibility": "on"
                },
                {
                  "hue": "#00d1ff"
                }
              ]
            },
            {
              "featureType": "transit.station.bus",
              "elementType": "labels.text",
              "stylers": [
                {
                  "visibility": "simplified"
                }
              ]
            },
            {
              "featureType": "transit.station.rail",
              "elementType": "all",
              "stylers": [
                {
                  "visibility": "simplified"
                },
                {
                  "hue": "#00cbff"
                }
              ]
            },
            {
              "featureType": "transit.station.rail",
              "elementType": "labels.text",
              "stylers": [
                {
                  "visibility": "simplified"
                }
              ]
            },
            {
              "featureType": "water",
              "elementType": "all",
              "stylers": [
                {
                  "color": "#7e8a8f"
                },
                {
                  "visibility": "on"
                }
              ]
            },
            {
              "featureType": "water",
              "elementType": "geometry.fill",
              "stylers": [
                {
                  "weight": "1.61"
                },
                {
                  "color": "#ccd9df"
                },
                {
                  "visibility": "on"
                }
              ]
            }
          ]
        });
        const icon = {
          url: "https://cdn.shopify.com/s/files/1/0648/5465/5188/files/marker.png?v=1657130426",
          size: new google.maps.Size(87, 105),
          scaledSize: new google.maps.Size(43, 52),
          anchor: new google.maps.Point(21, 52)
        };
        const marker = new google.maps.Marker({
          position: pos,
          clickable: false,
          draggable: false,
          map,
          icon
        });
        const label = document.createElement("div");
        label.classList = "labels";
        label.innerHTML = `<span>${mapEl.title}</span>`;
        newMapEl.appendChild(label);
        newMapEl.addEventListener("click", () => {
          label.style.display = "none";
        }, { once: true });
      });
    }
    fixAccordions() {
      const details = Array.from(this.el.querySelectorAll(".accordions details"));
      details && details.forEach((targetDetail) => {
        targetDetail.addEventListener("click", () => {
          details.forEach((detail) => {
            if (detail !== targetDetail) {
              detail.removeAttribute("open");
            }
          });
          if (!targetDetail.open) {
            this.to && this.to.kill();
            this.to = gsap.delayedCall(0.15, () => {
              targetDetail.scrollIntoView({ behavior: "smooth" });
            });
          }
        });
      });
    }
    createAnchorLink() {
      const title = this.anchorEl.innerText;
      const div = document.createElement("div");
      div.id = "anchor";
      div.innerHTML = "&nbsp;";
      this.anchorEl.parentNode.insertBefore(div, this.anchorEl.nextSibling);
      this.anchorEl.remove();
      const pageTitle = document.querySelector(".pageTitle");
      let topDiv = document.querySelector(".pageAnchor");
      if (!topDiv) {
        topDiv = document.createElement("div");
        topDiv.classList = "pageAnchor pad-x";
        pageTitle.parentNode.insertBefore(topDiv, pageTitle.nextSibling);
      }
      const link = document.createElement("a");
      link.href = "#anchor";
      link.innerText = title;
      link.classList = "btn t-h4";
      if (topDiv.children.length)
        link.classList.add("btn--ghost");
      topDiv.appendChild(link);
      link.addEventListener("click", (e2) => {
        e2.preventDefault();
        div.scrollIntoView({
          behavior: "smooth"
        });
      });
    }
  };

  // src/scripts/pages/blog.js
  var Blog = class {
    constructor(el) {
      this.el = el;
      this.onHoverLink = this.onHoverLink.bind(this);
      this.ul = this.el.querySelector("ul");
      this.items = Array.from(this.el.querySelectorAll("li"));
      this.links = Array.from(this.el.querySelectorAll("a"));
      const sorted = Array.from(this.ul.children).sort((a, b) => {
        return a.dataset.title > b.dataset.title ? 1 : -1;
      });
      sorted.forEach((item) => {
        this.ul.appendChild(item);
      });
      this.index = 0;
      this.links.forEach((link) => {
        link.addEventListener("mouseenter", this.onHoverLink);
      });
    }
    onHoverLink(e2) {
      e2.target.dataset.index = this.index;
      this.index++;
      if (this.index > 2)
        this.index = 0;
    }
  };

  // src/scripts/pages/contact.js
  var Contact = class {
    constructor(el) {
      this.el = el;
      this.mapsEl = this.el.querySelector(".js-map");
      this.mapsLoader = new google.maps.plugins.loader.Loader({
        apiKey: "AIzaSyCimOf7OxfDGmuhFJczGs2FroH-PW67xac",
        version: "weekly"
      });
      this.mapsLoader.load().then(this.createMaps.bind(this));
    }
    createMaps() {
      const { lat, lng } = this.mapsEl.dataset;
      const pos = { lat: parseFloat(lat), lng: parseFloat(lng) };
      const map = new google.maps.Map(this.mapsEl, {
        zoom: 12,
        center: pos,
        disableDefaultUI: true,
        zoomControl: true,
        styles: [
          {
            "featureType": "all",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "on"
              }
            ]
          },
          {
            "featureType": "administrative",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "color": "#444444"
              }
            ]
          },
          {
            "featureType": "administrative.province",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "administrative.locality",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "administrative.neighborhood",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "administrative.land_parcel",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "administrative.land_parcel",
            "elementType": "labels.text",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [
              {
                "color": "#ededeb"
              }
            ]
          },
          {
            "featureType": "landscape.man_made",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "simplified"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "off"
              },
              {
                "color": "#cee9de"
              },
              {
                "saturation": "2"
              },
              {
                "weight": "0.80"
              }
            ]
          },
          {
            "featureType": "poi",
            "elementType": "labels.text.fill",
            "stylers": [
              {
                "lightness": "-32"
              }
            ]
          },
          {
            "featureType": "poi.attraction",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "poi.park",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "on"
              }
            ]
          },
          {
            "featureType": "road",
            "elementType": "all",
            "stylers": [
              {
                "saturation": -100
              },
              {
                "lightness": 45
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "simplified"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "visibility": "on"
              },
              {
                "color": "#f5d6d6"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "labels.text",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "road.highway",
            "elementType": "labels.icon",
            "stylers": [
              {
                "hue": "#ff0000"
              },
              {
                "visibility": "on"
              }
            ]
          },
          {
            "featureType": "road.highway.controlled_access",
            "elementType": "labels.text",
            "stylers": [
              {
                "visibility": "simplified"
              }
            ]
          },
          {
            "featureType": "road.highway.controlled_access",
            "elementType": "labels.icon",
            "stylers": [
              {
                "visibility": "on"
              },
              {
                "hue": "#0064ff"
              },
              {
                "gamma": "1.44"
              },
              {
                "lightness": "-3"
              },
              {
                "weight": "1.69"
              }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "on"
              }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "labels.text",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "road.arterial",
            "elementType": "labels.icon",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "road.local",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "on"
              }
            ]
          },
          {
            "featureType": "road.local",
            "elementType": "labels.text",
            "stylers": [
              {
                "visibility": "simplified"
              },
              {
                "weight": "0.31"
              },
              {
                "gamma": "1.43"
              },
              {
                "lightness": "-5"
              },
              {
                "saturation": "-22"
              }
            ]
          },
          {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "off"
              }
            ]
          },
          {
            "featureType": "transit.line",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "on"
              },
              {
                "hue": "#ff0000"
              }
            ]
          },
          {
            "featureType": "transit.station.airport",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "simplified"
              },
              {
                "hue": "#ff0045"
              }
            ]
          },
          {
            "featureType": "transit.station.bus",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "on"
              },
              {
                "hue": "#00d1ff"
              }
            ]
          },
          {
            "featureType": "transit.station.bus",
            "elementType": "labels.text",
            "stylers": [
              {
                "visibility": "simplified"
              }
            ]
          },
          {
            "featureType": "transit.station.rail",
            "elementType": "all",
            "stylers": [
              {
                "visibility": "simplified"
              },
              {
                "hue": "#00cbff"
              }
            ]
          },
          {
            "featureType": "transit.station.rail",
            "elementType": "labels.text",
            "stylers": [
              {
                "visibility": "simplified"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "all",
            "stylers": [
              {
                "color": "#7e8a8f"
              },
              {
                "visibility": "on"
              }
            ]
          },
          {
            "featureType": "water",
            "elementType": "geometry.fill",
            "stylers": [
              {
                "weight": "1.61"
              },
              {
                "color": "#ccd9df"
              },
              {
                "visibility": "on"
              }
            ]
          }
        ]
      });
      const icon = {
        url: "https://cdn.shopify.com/s/files/1/0648/5465/5188/files/marker.png?v=1657130426",
        size: new google.maps.Size(87, 105),
        scaledSize: new google.maps.Size(43, 52),
        anchor: new google.maps.Point(21, 52)
      };
      const marker = new google.maps.Marker({
        position: pos,
        clickable: false,
        draggable: false,
        map,
        icon
      });
      const label = document.createElement("div");
      label.classList = "labels";
      label.innerHTML = `<span>Escape
Lab</span>`;
      this.mapsEl.appendChild(label);
      this.mapsEl.addEventListener("click", () => {
        label.style.display = "none";
      }, { once: true });
    }
  };

  // src/scripts/app.js
  var App = class {
    constructor() {
      this.onTick = this.onTick.bind(this);
      this.onResize = this.onResize.bind(this);
      this.transition = document.querySelector(".page-transition");
      gsap.registerPlugin(ScrollTrigger);
      this.transitionIn();
      this.initSmoothscroll();
      this.initPage();
      this.fixAccordions();
      requestAnimationFrame(() => { requestAnimationFrame(() => { this.initAnims(); }); });
      document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);
      this.baseVh = window.innerHeight;
      document.documentElement.style.setProperty("--base-viewport-height", `${this.baseVh}px`);
      const scrollbarW = Math.max(window.innerWidth - document.documentElement.clientWidth, 0);
      document.documentElement.style.setProperty("--scrollbar-width", `${scrollbarW}px`);
      window.addEventListener("resize", this.onResize);
    }
    initSmoothscroll() {
      this.isBodyLocked = document.body.className.includes("overflow-hidden");
      this.fixBodyLock();
      this.lenis = new r();
      gsap.ticker.add(this.onTick);
    }
    initPage() {
      const pageEl = document.querySelector("[data-page]");
      if (!pageEl)
        return;
      const { page } = pageEl.dataset;
      switch (page) {
        case "flexible":
          new FlexiblePage(pageEl);
          break;
        case "blog":
          new Blog(pageEl);
          break;
        case "contact":
          new Contact(pageEl);
          break;
      }
    }
    initAnims() {
      const sealPage = document.querySelector(".seal-subscription-page");
      if (sealPage) {
        sealPage.classList.add("js-section", "section");
        sealPage.dataset.theme = "dark";
      }
      const policyPage = document.querySelector("[data-page-type='policy']");
      if (policyPage) {
        policyPage.firstElementChild.classList.add("js-section", "section");
        policyPage.firstElementChild.dataset.theme = "dark";
      }
      const sections = Array.from(document.querySelectorAll(".js-section"));
      const bigTitles = Array.from(document.querySelectorAll(".js-anim-big-title"));
      const linesTitles = Array.from(document.querySelectorAll(".js-anim-lines"));
      const animIns = Array.from(document.querySelectorAll(".js-anim-in"));
      const parallaxIns = Array.from(document.querySelectorAll(".js-parallax-in"));
      const parallaxHeaders = Array.from(document.querySelectorAll(".js-parallax-header"));
      const parallax = Array.from(document.querySelectorAll(".js-parallax"));
      const initTheme = sections[0].dataset.theme || "light";
      document.body.dataset.theme = initTheme;
      sections.forEach((s2) => {
        const theme = s2.dataset.theme || "light";
        ScrollTrigger.create({
          trigger: s2,
          start: "top top",
          end: "bottom top",
          onEnter: () => {
            document.body.dataset.theme = theme;
          },
          onEnterBack: () => {
            document.body.dataset.theme = theme;
          }
        });
      });
      bigTitles.forEach((title) => {
        const split = Splitting({
          target: title,
          by: "chars"
        })[0];
        let animI = 0, xIndex = 0, yIndex = 0;
        split.words.forEach((word, index) => {
          animI = index % 2 ? 1 : 0;
          Array.from(word.children).forEach((char, subindex) => {
            let options = {
              opacity: 0
            };
            if ((subindex + animI) % 3 === 0) {
              options.xPercent = xIndex % 2 ? 50 : -50;
              xIndex++;
            } else if (animI % 2 === 0) {
              options.yPercent = yIndex % 2 ? -70 : 70;
              yIndex++;
            }
            char.index = randomInRange(0.1, 0.6);
            gsap.set(char, {
              ...options
            });
            animI++;
          });
        });
        const delay = title.dataset.delay ? parseFloat(title.dataset.delay) : 0;
        const tl = gsap.timeline({
          delay,
          scrollTrigger: {
            trigger: title,
            once: true,
            toggleClass: "-active"
          }
        });
        tl.to(split.chars, {
          xPercent: 0,
          yPercent: 0,
          ease: "expo.out",
          duration: 1.4,
          stagger: (index, target) => {
            return target.index;
          }
        }, 0);
        tl.to(split.chars, {
          opacity: 1,
          ease: "expo.out",
          duration: 0.8,
          stagger: (index, target) => {
            return target.index;
          }
        }, 0);
      });
      linesTitles.forEach((lines) => {
        const split = Splitting({
          target: lines,
          by: "lines"
        })[0];
        gsap.to(split.lines, {
          scrollTrigger: {
            trigger: lines,
            start: "top 80%",
            once: true,
            toggleClass: "-active"
          }
        });
      });
      [...parallaxIns, ...parallax].forEach((p) => {
        gsap.fromTo(p, {
          "--yPercent": -1
        }, {
          "--yPercent": 1,
          scrollTrigger: {
            trigger: p,
            start: "top bottom",
            end: "bottom top",
            scrub: true
          }
        });
      });
      parallaxHeaders.forEach((p) => {
        gsap.fromTo(p, {
          "--yPercent": 0
        }, {
          "--yPercent": 1,
          scrollTrigger: {
            trigger: p,
            start: "top top",
            end: "bottom top",
            scrub: true
          }
        });
      });
      animIns.forEach((anim) => {
        const delay = anim.dataset.delay ? parseFloat(anim.dataset.delay) : 0;
        gsap.fromTo(anim, {
          opacity: 0,
          y: 20
        }, {
          opacity: 1,
          y: 0,
          duration: 0.6,
          ease: "power2.out",
          delay,
          clearProps: "transform",
          scrollTrigger: {
            trigger: anim,
            start: "top 80%",
            once: true
          }
        });
      });
    }
    fixAccordions() {
      const headerDetails = Array.from(document.querySelectorAll("header-drawer .menu-drawer details"));
      headerDetails.forEach((targetDetail) => {
        targetDetail.addEventListener("click", () => {
          headerDetails.forEach((detail) => {
            if (detail !== targetDetail) {
              detail.removeAttribute("open");
            }
          });
        });
      });
      const productDetails = Array.from(document.querySelectorAll(".productHero__accordions details"));
      productDetails.length && productDetails.forEach((targetDetail) => {
        targetDetail.addEventListener("click", () => {
          productDetails.forEach((detail) => {
            if (detail !== targetDetail) {
              detail.removeAttribute("open");
            }
          });
        });
      });
    }
    fixBodyLock() {
      const observer = new MutationObserver((mutationList, observer2) => {
        mutationList.forEach((mutation) => {
          if (mutation.type === "attributes" && (mutation.attributeName === "class" || mutation.attributeName === "style")) {
            const bodyLocked = document.body.className.includes("overflow-hidden") || document.body.style.overflow === "hidden";
            if (this.isBodyLocked !== bodyLocked) {
              this.isBodyLocked = bodyLocked;
              if (bodyLocked)
                this.lenis.stop();
              else
                this.lenis.start();
            }
          }
        });
      });
      observer.observe(document.body, { attributes: true });
    }
    transitionIn() {
      this.transition.classList.add("-hidden");
    }
    transitionOut() {
      this.transition.classList.add("-will-go");
      requestAnimationFrame(() => {
        this.transition.classList.add("-out");
      });
    }
    listenPageChange() {
      const anchors = document.querySelectorAll("a");
      anchors.forEach((anchor) => {
        if (anchor.hostname !== window.location.hostname || anchor.pathname === window.location.pathname) {
          return;
        }
        anchor.addEventListener("click", this.onAnchorClick.bind(this, anchor));
      });
    }
    onAnchorClick(anchor, e2) {
      e2.preventDefault();
      gsap.set(this.transition, { opacity: 0, scaleY: 1 });
      gsap.to(this.transition, {
        opacity: 1,
        duration: 0.3,
        ease: "power2.out",
        onComplete: () => {
          window.location = anchor.href;
        }
      });
    }
    onTick(time) {
      this.lenis.raf(time * 1e3);
    }
    onResize() {
      document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);
      const scrollbarW = Math.max(window.innerWidth - document.documentElement.clientWidth, 0);
      document.documentElement.style.setProperty("--scrollbar-width", `${scrollbarW}px`);
      if (Math.abs(window.innerHeight - this.baseVh) > 100) {
        this.baseVh = window.innerHeight;
        document.documentElement.style.setProperty("--base-viewport-height", `${this.baseVh}px`);
      }
    }
  };

  // src/scripts/index.js
  window.addEventListener("DOMContentLoaded", () => {
    document.documentElement.classList.add("is-dom-ready");
    new App();
  });
})();
